// import { ColumnDef } from '@tanstack/react-table'
// import React from 'react'
// import Actionbuttons from './ActionModel'

// export interface Question {
// 	_id: string
// 	parentId: string
// 	name: string
// 	question: string
// 	answers: string[]
// 	correctAnswer: string[]
// 	marks: number
// 	questionType: string
// 	sectionId: string
// 	subSectionId: string
// 	sectionName: string
// 	subSectionName?: string
// 	createdBy?: string
// 	createdAt?: string
// 	updatedAt?: string
// }

// const truncate = (text: string, length = 12) =>
// 	text.length > length ? text.slice(0, length) + '...' : text

// const CustomTableColumns = (fetchData: () => void): ColumnDef<Question>[] => [
// 	// {
// 	//   accessorKey: "_id",
// 	//   header: "Question ID",
// 	//   cell: ({ row }) => <div>{truncate(row.original._id)}</div>,
// 	// },

// 	{
// 		accessorKey: 'sectionName',
// 		header: 'Section',
// 		cell: ({ row }) => <div>{row.original.sectionName}</div>
// 	},
// 	{
// 		accessorKey: 'subSectionName',
// 		header: 'Sub-Section',
// 		cell: ({ row }) => <div>{row.original.subSectionName}</div>
// 	},
// 	{
// 		accessorKey: 'questionType',
// 		header: 'Question Type',
// 		cell: ({ row }) => <div>{row.original.questionType}</div>
// 	},
// 	// {
// 	// 	accessorKey: 'name',
// 	// 	header: 'Question Name',
// 	// 	cell: ({ row }) => <div>{row.original.name}</div>
// 	// },
// 	{
// 		accessorKey: 'question',
// 		header: 'Question',
// 		cell: ({ row }) => {
// 			const fullQuestion = row.original.question
// 			const words = fullQuestion.split(' ')
// 			const chunks: string[] = []

// 			for (let i = 0; i < words.length; i += 10) {
// 				chunks.push(words.slice(i, i + 10).join(' '))
// 			}

// 			return (
// 				<div>
// 					{chunks.map((chunk, index) => (
// 						<div key={index}>{chunk}</div>
// 					))}
// 				</div>
// 			)
// 		}
// 	},
// 	{
// 		header: 'Option 1',
// 		cell: ({ row }) => <div>{row.original.answers[0]}</div>
// 	},
// 	{
// 		header: 'Option 2',
// 		cell: ({ row }) => <div>{row.original.answers[1]}</div>
// 	},
// 	{
// 		header: 'Option 3',
// 		cell: ({ row }) => <div>{row.original.answers[2]}</div>
// 	},
// 	{
// 		header: 'Option 4',
// 		cell: ({ row }) => <div>{row.original.answers[3]}</div>
// 	},
// 	{
// 		accessorKey: 'marks',
// 		header: 'Marks',
// 		cell: ({ row }) => <div>{row.original.marks}</div>
// 	},
// 	{
// 		header: 'Actions',
// 		cell: ({ row }) => (
// 			<Actionbuttons parentId={row.original.parentId} refreshData={fetchData} />
// 		)
// 	}
// ]

// export default CustomTableColumns
import React from 'react'
import { ColumnDef } from '@tanstack/react-table'
import Actionbuttons from './ActionModel'
import ExpandableCell from './ExpandableCell'

export interface Question {
	_id: string
	parentId: string
	name: string
	question: string
	answers: string[]
	correctAnswer: string[]
	marks: number
	questionType: string
	sectionId: string
	subSectionId: string
	sectionName: string
	subSectionName?: string
	createdBy?: string
	createdAt?: string
	updatedAt?: string
}

const CustomTableColumns = (fetchData: () => void): ColumnDef<Question>[] => [
	{
		accessorKey: 'sectionName',
		header: 'Section',
		cell: ({ row }) => <div>{row.original.sectionName}</div>
	},
	{
		accessorKey: 'subSectionName',
		header: () => <div style={{ whiteSpace: 'nowrap' }}>Sub-Section</div>,
		cell: ({ row }) => <div>{row.original.subSectionName}</div>
	},
	{
		accessorKey: 'questionType',
		header: () => <div style={{ whiteSpace: 'nowrap' }}>Question Type</div>,
		cell: ({ row }) => <div>{row.original.questionType}</div>
	},

	{
		accessorKey: 'question',
		header: 'Question',
		cell: ({ row }) => <ExpandableCell text={row.original.question} width="250px" />
	},

	{
		accessorKey: 'Option 1',
		header: () => <div style={{ whiteSpace: 'nowrap' }}>Option 1</div>,
		cell: ({ row }) => <div>{row.original.answers[0]}</div>
	},
	{
		accessorKey: 'Option 2',
		header: () => <div style={{ whiteSpace: 'nowrap' }}>Option 2</div>,
		cell: ({ row }) => <div>{row.original.answers[1]}</div>
	},
	{
		accessorKey: 'Option 3',
		header: () => <div style={{ whiteSpace: 'nowrap' }}>Option 3</div>,
		cell: ({ row }) => <div>{row.original.answers[2]}</div>
	},
	{
		accessorKey: 'Option 4',
		header: () => <div style={{ whiteSpace: 'nowrap' }}>Option 4</div>,
		cell: ({ row }) => <div>{row.original.answers[3]}</div>
	},
	{
		accessorKey: 'marks',

		header: () => <div style={{ whiteSpace: 'nowrap' }}>Marks</div>,
		cell: ({ row }) => <div>{row.original.marks}</div>
	},
	{
		header: 'Actions',
		cell: ({ row }) => (
			<Actionbuttons parentId={row.original.parentId} refreshData={fetchData} />
		)
	}
]

export default CustomTableColumns
